import React, { useState } from 'react';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import CustomTooltip from '../../../components/common/tooltip';
import { Select } from '../form-fields/Select';
import {
  fontSizeOptions,
  fontWeightOptions,
} from '../../puck/reusable-props/font';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { FieldLabel } from '@measured/puck';
import { PromoProps } from './PromoCode';
import InputField from '../../../components/common/input-field';

type PromoButtonProps = {
  value: PromoProps;
  onChange: (_value: PromoProps) => void;
};

const PromoButton = ({ value, onChange }: PromoButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>Button</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3 m-auto border border-gray-300 rounded py-2 px-4">
          <FieldLabel
            label={
              (
                <CustomTooltip title="Text">
                  <span>Text</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <InputField
              value={value?.text}
              onChange={text => {
                onChange({
                  ...value,
                  text: text,
                });
              }}
            />
          </FieldLabel>
          <FieldLabel
            label={
              (
                <CustomTooltip title="fontSize">
                  <span>Font Size</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <Select
              className="pagebuilder-theme"
              value={value?.fontSize}
              onChange={e =>
                onChange({
                  ...value,
                  fontSize: e.target.value,
                })
              }
              options={fontSizeOptions}
            />
          </FieldLabel>

          <FieldLabel
            label={
              (
                <CustomTooltip title="fontWeight">
                  <span>Font Weight</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <Select
              value={value?.fontWeight}
              onChange={e =>
                onChange({
                  ...value,
                  fontWeight: e.target.value,
                })
              }
              options={fontWeightOptions}
            />
          </FieldLabel>
          <ColorPicker
            value={value?.textColor}
            onChange={textColor =>
              onChange({
                ...value,
                textColor: textColor,
              })
            }
            label={'Text Color'}
            tooltip={'textColor'}
          />
          <ColorPicker
            value={value?.backgroundColor}
            onChange={bgColor =>
              onChange({
                ...value,
                backgroundColor: bgColor,
              })
            }
            label={'Background Color(Before Input)'}
            tooltip={'backgroundColor(Before Input)'}
          />
          <ColorPicker
            value={value?.backgroundColorAI}
            onChange={bgColor =>
              onChange({
                ...value,
                backgroundColorAI: bgColor,
              })
            }
            label={'Background Color(After Input)'}
            tooltip={'backgroundColor(After Input)'}
          />
        </div>
      )}
    </div>
  );
};

export default PromoButton;
